import React from 'react';
import Select from "react-select";
import {withStore} from "../../../hocs";
import {observer} from "mobx-react";
import {Link} from "react-router-dom";

// @ts-ignore
@withStore
@observer
export class HeaderMenuTp extends React.Component {
    render() {

        // @ts-ignore
        const {store} = this.props;
        const {selectedClient, setSelectedOptionClient, optionsClient}=store?.mainStore;

        return (
            <>
                <div className="nav-term-wrapper">
                        <div className="select-box">
                            <Link to={'/client'}>
                            <svg className="client-svg" width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M16.4348 6.07878C16.4348 3.51594 18.5124 1.43835 21.0752 1.43835C23.6381 1.43835 25.7157 3.51594 25.7157 6.07878C25.7157 8.64162 23.6381 10.7192 21.0752 10.7192C18.5124 10.7192 16.4348 8.64162 16.4348 6.07878ZM21.0752 3.29452C19.5375 3.29452 18.291 4.54108 18.291 6.07878C18.291 7.61648 19.5375 8.86303 21.0752 8.86303C22.6129 8.86303 23.8595 7.61648 23.8595 6.07878C23.8595 4.54108 22.6129 3.29452 21.0752 3.29452ZM17.0045 15.2723C18.0209 14.1839 19.4686 13.5035 21.0752 13.5035C24.1506 13.5035 26.6437 15.9966 26.6437 19.072C26.6437 19.5845 27.0593 20.0001 27.5718 20.0001C28.0844 20.0001 28.4999 19.5845 28.4999 19.072C28.4999 14.9714 25.1758 11.6473 21.0752 11.6473C19.0048 11.6473 17.1323 12.4948 15.7856 13.8618C16.2319 14.2207 16.6597 14.7794 17.0045 15.2723Z"
                                      fill="#074DB7"/>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M9 0.25C5.8934 0.25 3.375 2.7684 3.375 5.875C3.375 8.9816 5.8934 11.5 9 11.5C12.1066 11.5 14.625 8.9816 14.625 5.875C14.625 2.7684 12.1066 0.25 9 0.25ZM5.625 5.875C5.625 4.01104 7.13604 2.5 9 2.5C10.864 2.5 12.375 4.01104 12.375 5.875C12.375 7.73896 10.864 9.25 9 9.25C7.13604 9.25 5.625 7.73896 5.625 5.875Z"
                                      fill="#074DB7"/>
                                <path
                                    d="M2.25 21.625C2.25 17.8971 5.27208 14.875 9 14.875C12.7279 14.875 15.75 17.8971 15.75 21.625C15.75 22.2463 16.2537 22.75 16.875 22.75C17.4963 22.75 18 22.2463 18 21.625C18 16.6544 13.9706 12.625 9 12.625C4.02944 12.625 0 16.6544 0 21.625C0 22.2463 0.50368 22.75 1.125 22.75C1.74632 22.75 2.25 22.2463 2.25 21.625Z"
                                    fill="#074DB7"/>
                            </svg>
                            </Link>
                            <span className="select-box-label-title">Клиент</span>
                            <Select className="select header-select-top"
                                    classNamePrefix="react-select"
                                    value={selectedClient}
                                    onChange={setSelectedOptionClient}
                                    options={optionsClient}
                                    isDisabled={Boolean(!optionsClient?.length)}
                            />
                        </div>
                </div>
            </>
        );
    }
}


